import type { ComponentProps, ReactNode } from 'react'

import { Menu } from '@/src/elements/menu/Menu'
import { Drawer } from '@/src/elements/navigation/Drawer'

export const MenuDrawer = (props: ComponentProps<typeof Drawer>): ReactNode => (
  <Drawer
    backBehavior="history"
    screenOptions={{
      drawerStyle: { width: 375 },
      headerShown: false,
      drawerContentStyle: { backgroundColor: 'white' },
    }}
    drawerContent={({ navigation }) => <Menu onClose={navigation.closeDrawer} />}
    {...props}
  />
)
